import {atom} from "recoil";
import {recoilPersist} from "recoil-persist";

const {persistAtom} = recoilPersist();

export const cartItemsJSON = atom({
    key: "cartItemsJSON",
    default: [],
    // effects_UNSTABLE: [persistAtom],
});
export const variantIndex = atom({
    key: "variantIndex",
    default: 0
});
export const totalPay = atom({
    key: "totalPay",
    default: 0.00,
});
export const products = atom({
    key: "products",
    default: 0.00,
});



// !info for the new convention
// export const company = atom({
//     key: "company",
//     default: "",
// });             
// export const identifier = atom({
//     key: "identifier",
//     default: "",
// });
// export const isVerified = atom({
//     key: "isVerified",
//     default: false,
// });
// export const isPremium = atom({
//     key: "isPremium",
//     default: false,
// });

